<template>
  <div class="lamp-bg m-t-35" :class="{'lamp-default': !stop, 'lamp-active': stop}">
    <div class="table-bg table-warp1" :class="{ 'stop': stop}"></div>
    <div class="table-bg table-warp2" :class="{ 'stop': stop}"></div>
    <div class="table-bg table-warp3" :class="{ 'stop': stop}"></div>
  </div>
</template>

<style scoped>
  .lamp-bg {
    position: relative;
    width: 640px;
    height: 640px;
    background-size: 100%;
  }
  .lamp-default {
    background: url('../../../assets/images/lamp-default.png') no-repeat;
  }
  .lamp-active {
    background: url('../../../assets/images/lamp-active.png') no-repeat;
  }
  .table-bg {
    position: absolute;
    width: 140px;
    height: 180px;
  }
  .table-warp1 {
    bottom: 180px;
    background: url(../../../assets/images/table1.png) no-repeat;
    animation: move1 2s linear infinite alternate;
    animation-delay: 0s;
  }
  .table-warp2 {
    left: 210px;
    top: 60px;
    background: url(../../../assets/images/table2.png) no-repeat;
    animation: move2 2s linear infinite alternate;
    animation-delay: .5s;
  }
  .table-warp3 {
    right: 70px;
    top: 80px;
    background: url(../../../assets/images/table3.png) no-repeat;
    animation: move3 2s linear infinite alternate;
    animation-delay: 1s;
  }
  .stop {
    animation-play-state: paused;
  }
  @keyframes move1 {
    from { left: 0; bottom: 180px; }
    to { left: 40px; bottom: 220px; }
  }
  @keyframes move2 {
    from { left: 210px; top: 60px; }
    to { left: 250px; top: 20px; }
  }
  @keyframes move3 {
    from { right: 70px; top: 80px; }
    to { right: 30px; top: 40px; }
  }
  @media (max-width: 1500px) {
    .lamp-bg {
      position: relative;
      width: 460px;
      height: 460px;
      background-size: 100%;
    }
    .table-bg {
      position: absolute;
      width: 100px;
      height: 130px;
      background-size: 100%;
    }
    .table-warp1 {
      bottom: 130px;
    }
    .table-warp2 {
      left: 151px;
      top: 43px;
    }
    .table-warp3 {
      right: 50px;
      top: 57px;
    }
    @keyframes move1 {
      from { left: 0; bottom: 130px; }
      to { left: 29px; bottom: 158px; }
    }
    @keyframes move2 {
      from { left: 151px; top: 43px; }
      to { left: 180px; top: 14px; }
    }
    @keyframes move3 {
      from { right: 50px; top: 58px; }
      to { right: 22px; top: 29px; }
    }
  }
</style>

<script>
  export default {
    props: {
      stop: {
        type: Boolean,
        default() {
          return false
        }
      }
    },
    data() {
      return {
      }
    },
    watch: {
      'stop'() {
        console.log(this.stop)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// deskAnimation.vue?0e9c2019